import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "abap",
  extensions: [".abap"],
  aliases: ["abap", "ABAP"],
  loader: () => import('./abap.js')
});
